import axios from "axios"
import { sendCaptureExceptionToSentry } from "utils/sentry"
import config from "config"
import { IMovieShowTime, ICinema } from "../../../interfaces"

const get = async <T>(endpoint: string): Promise<T> => {
  const res = await axios.get(endpoint)
  if (res.status !== 200) {
    throw new Error()
  }
  return res.data as T
}

interface IGetMovieShowTimeResult {
  cinema: ICinema
  showtime: IMovieShowTime
}

type GetMovieShowTime = (
  cinemaCode?: string
) => Promise<IGetMovieShowTimeResult | null>

export const getMovieShowTime: GetMovieShowTime = async (cinemaCode) => {
  const path = config("host") + `/cinema/${cinemaCode}`
  try {
    const jsonRes = await get<IGetMovieShowTimeResult>(path)
    return jsonRes
  } catch (error) {
    sendCaptureExceptionToSentry({
      error,
      level: "error",
      transactionName: `Failed to fetch data from ${path} endpoint.`,
    })
    return null
  }
}
